import './styles/_spinnerText.scss'

interface SpinnerTextProps {
  typeClass?: string
}

export const SpinnerText = ({typeClass = "loading-container "}: SpinnerTextProps) => {
  return (
    <div className={typeClass} data-testid="loading-spinner">
      <span className="loading-text" data-testid="loading-text">
        <span className="loading-word">Cargando</span>
        <span className="loading-dot">.</span>
        <span className="loading-dot">.</span>
        <span className="loading-dot">.</span>
      </span>

      {
        typeClass === "loading-container-full" && (
          <span className="loading-text">
            Por favor no cierre la pestaña hasta que el proceso haya finalizado.
          </span>
        )
      }
    </div>
  )
}

